<template>
  <div>
    <v-card fill-height>
      <v-layout px-3 py-3 row wrap>
        <v-flex md12>
          <v-select
            :items="notificationTypesList"
            v-model="selectedNotificationTypes"
            label="Select notification type"
          ></v-select>
        </v-flex>
        <v-flex md12>
          <v-select
            :items="eventsList"
            v-model="selectedEvent"
            label="Select an event"
          ></v-select>
        </v-flex>
        <v-flex xs12 md7>
          <v-textarea
            outline
            label="Message"
            rows="5"
            v-model="notificationMessage"
          ></v-textarea>
        </v-flex>
        <v-flex xs12 md5 class="pl-2" v-if="!isLeadAddedEvent">
          <v-btn small @click="pasteVar('{!!$case_id!!}')">Case ID</v-btn>
          <v-btn small @click="pasteVar('{!!$case_name!!}')">Case name</v-btn>
          <v-btn small @click="pasteVar('{!!$quotation_link!!}')">Quotation link</v-btn>
          <v-btn small @click="pasteVar('{!!$agreement_link!!}')">Agreement link</v-btn>
          <v-btn small @click="pasteVar('{!!$date_time_of_funerals!!}')">Date time of funerals</v-btn>
          <v-btn small @click="pasteVar('{!!$amount_of_days!!}')">Amount of days</v-btn>
          <v-btn small @click="pasteVar('{!!$location!!}')">Location</v-btn>
          <v-btn small @click="pasteVar('{!!$selected_package!!}')">Selected Package</v-btn>
          <v-btn small @click="pasteVar('{!!$selected_casket!!}')">Selected Casket</v-btn>
          <v-btn small @click="pasteVar('{!!$selected_products!!}')">Selected Products</v-btn>
          <v-btn small @click="pasteVar('{!!$selected_products_list_text!!}')">Selected Products-Amount List Text</v-btn>
        </v-flex>
        <v-flex md12>
          <v-textarea
            outline
            label="Recipients (comma-separated values)"
            rows="2"
            v-model="notificationRecipients"
          ></v-textarea>
        </v-flex>
        <v-flex md12>
          <v-select
            v-model="selectedRoles"
            :items="roles"
            chips
            label="Roles"
            multiple
            outline
          ></v-select>
        </v-flex>
        <v-flex v-if="!isLeadAddedEvent">
          <v-checkbox
            label="Send to case Client?"
            v-model="sendToClient"
          ></v-checkbox>
        </v-flex>
        <v-flex md12>
          <v-checkbox
            label="Is active?"
            v-model="notificationIsActive"
          ></v-checkbox>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-btn
          block
          color="primary"
          @click="saveNotification"
        >Save settings</v-btn>
      </v-card-actions>
    </v-card>
    <AppEditTwilioNotificationsDialog></AppEditTwilioNotificationsDialog>
    <v-flex mt-5>
      <v-data-table
        :headers="tableHeaders"
        :items="items"
        hide-actions
        class="elevation-1"
        :loading="loadingInProgress"
        :no-data-text="loadingItemsText"
      >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.vendor }}</td>
        <td>{{ props.item.message }}</td>
        <td>{{ props.item.event.description || props.item.event.name }}</td>
        <td>{{ props.item.recipients_string }}</td>
        <td>{{ getRoleNamesByIds(props.item.roles) }}</td>
        <td>{{ props.item.send_to_client }}</td>
        <td>{{ props.item.is_active }}</td>
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.updated_at }}</td>
        <td class="justify-left layout px-0">
          <v-btn icon class="mx-0" @click="editElement(props.item.id)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteDialog(props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
          <ConfirmationDialog ref="confirm"></ConfirmationDialog>
        </td>
      </template>
      </v-data-table>
    </v-flex>
    <v-flex mt-5>
      <v-card>
        <v-toolbar color="teal" dark>
          <v-toolbar-title class="text-xs-center">Built in notifications</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-list two-line subheader>
          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="green">chat_bubble</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Case Manager Changed</v-list-tile-title>
              <v-list-tile-sub-title>Old manager and new will receive sms message: "Hello! Case Manager for case #x has been changed."</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="green">chat_bubble</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Products Changed In Case</v-list-tile-title>
              <v-list-tile-sub-title>Case manager (email) and each attached vendor (sms and email) will receive notification with information about changed product</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile>
            <v-list-tile-action>
              <v-icon color="green">chat_bubble</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Products Detached From Case</v-list-tile-title>
              <v-list-tile-sub-title>Each attached vendor will receive sms with information about detached product</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-flex>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import CrudAPI from '@/api/resources/crud'
  import AppEditTwilioNotificationsDialog from '@/components/dialogs/AppEditNotificationsDialog'
  import resourcesMixins from '@/mixins/Resources'
  import notificationsMixins from '@/mixins/Notifications'
  import AppMainDialog from '@/components/AppMainDialog'
  import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'
  import { mapGetters } from 'vuex'

  export default {
    name: 'TwilioNotifications',
    components: { AppMainDialog, AppEditTwilioNotificationsDialog, ConfirmationDialog },
    mixins: [ resourcesMixins, notificationsMixins ],
    computed: {
      ...mapGetters({
        roles: 'allRoles',
        getRoleNamesByIds: 'getRoleNamesByIds'
      }),
      isLeadAddedEvent () {
        let ev = this.eventsList.find(e => e.value === this.selectedEvent)
        return (ev !== undefined) && ev.text === 'New Lead Added'
      }
    },
    data () {
      return {
        resources: 'notifications',
        selectedNotificationTypes: null,
        sendToClient: false,
        selectedRoles: [],
        isEmailType: false
      }
    },
    watch: {
      selectedNotificationTypes (v) {
        this.isEmailType = v === 'email'
      }
    },
    methods: {
      deleteDialog (id) {
        this.$refs.confirm.open('Are you sure?', 'Delete', {}).then((confirm) => {
          this.deleteElement(id)
        })
      },
      loadListing () {
        let result = CrudAPI.dfsResourceIndex(this.resources)

        result.then(this.loadListingSuccess, this.loadListingError)
      },
      pasteVar (v) {
        this.notificationMessage = this.notificationMessage + v
      },
      saveNotification () {
        let payload = {
          events_id: this.selectedEvent,
          recipients: this.notificationRecipients,
          message: this.notificationMessage,
          vendor: this.selectedNotificationTypes,
          is_active: this.notificationIsActive,
          send_to_client: this.sendToClient,
          roles: this.selectedRoles
        }

        let save = CrudAPI.dfsResourceStore(this.resources, payload)

        save.then(result => {
          this.$bus.$emit('resource-added')

          this.dialogMessage = 'Successfully added'

          this.dialogOpen = true
        }, error => {
          let handle = error // eslint-disable-line
        })
      }
    },
    beforeCreate () {
      this.$store.dispatch('getAllRoles')
    }
  }
</script>



// WEBPACK FOOTER //
// Notifications.vue?7ac6a37c